module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../node_modules/babel-loader/lib/index.js!./DealsContainerResolver.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/Promotion/DealsContainerResolver.js
// module id = 1180
// module chunks = 58